import type { TradeFilter } from '@einhaus/project314-types';
import { DeleteButton } from '@/components/UI';
import { formatPositionSide } from '@/utils/tradeSemantics';

interface TradeFilterItemProps {
    filter: TradeFilter;
    onRemove: (id: string) => void;
}

const TradeFilterItem = ({ filter, onRemove }: TradeFilterItemProps) => {
    const { id, entityType, field, operator, value, tradeDirection } = filter;

    const getOperatorSymbol = (op: string): string => {
        switch (op) {
            case 'greaterThan':
                return '>';
            case 'lessThan':
                return '<';
            case 'greaterThanEqual':
                return '>=';
            case 'lessThanEqual':
                return '<=';
            case 'equal':
                return '=';
            default:
                return op;
        }
    };

    return (
        <div className="inline-flex items-center bg-dark text-light border border-zinc-600 rounded p-2 mr-2 mb-2" id={id}>
            <span>
                {entityType} - Position side: {formatPositionSide(tradeDirection)} - {field} {getOperatorSymbol(operator)} {value}
            </span>
            <DeleteButton
                aria-label="Remove filter"
                className="ml-2"
                showText={false}
                size="sm"
                type="button"
                onClick={() => onRemove(id)}
            />
        </div>
    );
};

export default TradeFilterItem;
